import { Toaster } from "@/components/ui/sonner";
import { MyDataContext } from "@/hooks/context/useMyDataContext";
import { useCancelMailingMutation, useGetMyMailerQuery } from "@/store/apis/userApi";
import { PropsWithChildren } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "sonner";

const CancelMailingProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams<{ id: string }>();
  const { data, isError, isLoading } = useGetMyMailerQuery(
    { id },
    { skip: !id || id === "undefined" || id === "null" }
  );
  const [cancelMailing, { isLoading: cancelLoading, isSuccess }] = useCancelMailingMutation();
  const navigator = useNavigate();

  const onCancel = () => {
    navigator("/");
  };
  const onConfirm = () => {
    if (!id) return;
    cancelMailing({ id })
      .unwrap()
      .then(async (res) => {
        if (res.ok) {
          toast.success("שירותי המיילים בוטלו בהצלחה", {
            description: "לא תקבל יותר מיילים מאיתנו.",
            descriptionClassName: "text-sm text-zoooz-text",
            action: {
              label: "חזרה לדף הבית",
              onClick: () => {
                navigator("/");
              },
            },
          });
          await new Promise((resolve) => setTimeout(resolve, 3000));
          navigator("/");
        } else {
          toast.error("שירותי המיילים לא בוטלו", {
            description: "אנא נסה שוב מאוחר יותר.",
          });
        }
      });
  };


  return (
    <MyDataContext.Provider
      value={{ data: data?.data, isError, isLoading, onCancel, onConfirm, actionDisabled: cancelLoading || isSuccess }}>
      <Toaster
        position="top-center"
        closeButton={false}
        swipeDirections={[]}
        toastOptions={{
          duration: Infinity,
          classNames: {
            toast: "rtl flex items-start gap-3 rounded-lg bg-white text-zoooz-text shadow-lg",
            title: "font-bold",
            actionButton: "text-white underline underline-offset-2 font-semibold ",
          },
        }}
        offset={16}
      />
      {children}
    </MyDataContext.Provider>
  );
};
export default CancelMailingProvider;
